import React from 'react';
import styled from 'styled-components';
import { Captions } from 'components/Typography';
import { Accordion, Divider, AccordionDetails } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';
import breakpoints from 'utils/breakpoints';

export const FirstAccordion = styled(({ color, ...otherProps }) => (
  <Accordion {...otherProps} />
))`
  background-color: #ffffff;
  background-repeat: no-repeat;
  border-radius: 10px !important;
  margin-top: -20px !important;
  margin-bottom: 20px !important;
`;
export const StyledCaption = styled(Captions)`
  && {
    color: #162952;
    font-size: 14px !important;
    line-height: 17px !important;
    margin: 0;
    padding: 8px 0;
  }
`;
export const StyledBody = styled(Captions)`
  && {
    color: #162952;
    font-size: 13px !important;
    line-height: 29px !important;
    margin: 0;
    letter-spacing: 0.4px;
    @media (max-width: ${breakpoints.xs}) {
      font-size: 12px !important;
      line-height: 20px !important;
    }
  }
`;

export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    color: #ffffff;
    font-size: 20px !important;
    line-height: 25px !important;
    margin: 0;
  }
`;
export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
    left: 10px;
    right: 0px;
  }
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    border-top-color: #979797;
    padding: 8px 16px 16px;
    border-left: none;
  }
`;
